import axios from 'src/utils/axios';
import { URLS } from 'src/utils/url';

class CommunityService {
	getAll(params) {
		return axios.get(URLS.COMMUNITY, { params });
	}

	getDetails(id) {
		return axios.get(URLS.COMMUNITY + '/' + id);
	}

	delete(id) {
		return axios.delete(URLS.COMMUNITY + '/' + id);
	}

	invokeUpsert(params) {
		return axios({
			method: params?.id ? 'PUT' : 'POST',
			url: params?.id ? `${URLS.COMMUNITY}/${params?.id}` : URLS.COMMUNITY,
			data: params
		});
	}

	getPartecipants(communityId, params) {
		return axios.get(`${URLS.COMMUNITY}/${communityId}/participants`, {
			params
		});
	}

	downloadAll(id) {
		return axios({
			url: `${URLS.COMMUNITY}/${id}/templates`,
			method: 'GET',
			responseType: 'blob'
		});
	}
}

const communityService = new CommunityService();

export default communityService;
